import { render, staticRenderFns } from "./UserGroupUsersViewer.vue?vue&type=template&id=0cdddfd6&scoped=true"
import script from "./UserGroupUsersViewer.vue?vue&type=script&lang=js"
export * from "./UserGroupUsersViewer.vue?vue&type=script&lang=js"
import style0 from "./UserGroupUsersViewer.vue?vue&type=style&index=0&id=0cdddfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdddfd6",
  null
  
)

export default component.exports